module.exports = __webpack_public_path__ + "img/icon-handmade.1dd4e0fb.svg";